(() => {
  const LEGACY = new Set(['collection-products', 'product-grid', 'filter-results']);
  const INIT_RETRY_MS = [0, 80, 200, 450];

  function hashFromUrl(url) {
    return decodeURIComponent((url.hash || '').slice(1));
  }

  function currentHash() {
    return hashFromUrl(window.location);
  }

  function normalizePath(path) {
    return path.replace(/\/$/, '') || '/';
  }

  function resolveTarget(hash) {
    if (!hash) return null;
    return (
      document.getElementById(hash) ||
      (LEGACY.has(hash) &&
        (document.querySelector('.collection-jump-anchor') || document.getElementById('filter-results'))) ||
      null
    );
  }

  function isJumpHash(hash) {
    return Boolean(hash && (resolveTarget(hash) || LEGACY.has(hash)));
  }

  function scrollToHash(hash, behavior = 'auto') {
    const el = resolveTarget(hash);
    if (!el) return;
    el.scrollIntoView({ block: 'start', behavior });
  }

  function scheduleInitScroll() {
    const hash = currentHash();
    if (!isJumpHash(hash)) return;
    INIT_RETRY_MS.forEach((delay) => {
      window.setTimeout(() => scrollToHash(hash, 'auto'), delay);
    });
  }

  // Same-page: prevent native hash nav (Boost re-renders on hashchange). No replaceState.
  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[href*="#"]');
      if (!link) return;

      let url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }

      const hash = hashFromUrl(url);
      if (!isJumpHash(hash)) return;

      const href = link.getAttribute('href') || '';
      if (!href.startsWith('#') && normalizePath(url.pathname) !== normalizePath(window.location.pathname)) {
        return;
      }

      event.preventDefault();
      scrollToHash(hash);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInitScroll, { once: true, passive: true });
  } else {
    scheduleInitScroll();
  }

  window.addEventListener('load', scheduleInitScroll, { passive: true });
  window.addEventListener('pageshow', (event) => event.persisted && scheduleInitScroll(), { passive: true });
  window.addEventListener('hashchange', () => {
    const hash = currentHash();
    if (isJumpHash(hash)) scrollToHash(hash);
  }, { passive: true });
})();
